import { Button, Col, Form, Input, InputPicker, Schema } from 'rsuite';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlexboxGrid } from 'rsuite';

import { faIR } from 'date-fns-jalali/locale';
import { format } from 'date-fns-jalali';
import { DatePicker } from '../../../components/form/datepicker/datepicker';

const { StringType, NumberType } = Schema.Types;
// todo: validation
const model = Schema.Model({
  FullName: StringType(''),
  Category: StringType(''),
  City: StringType(''),
  Education: StringType(''),
  // ProfessionBeginTimeStamp: StringType(''),
  Job: StringType(''),
  PriceFor30M: NumberType(''),
  PriceFor1H: NumberType(''),
  Description: StringType('')
});

// import { handlePostConsulteeReport } from '../../api-handler';
import { showToast } from '../../../utils/toast';
import Field from '../../../components/form/field';
import TextAreaField from '../../../components/form/textarea-field';
import TextField from '../../../components/form/textfield';
import {
  handleGetAdminConsultantRegister,
  handlePostAdminConsultantRegister,
  handlePutAdminConsultantRegister
} from '../../../api-handler/admin';

export const AdminRegisterConsultant = (props: {
  username: string;
  onAcceptConsultant: () => void;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [timeStamp, setTimeStamp] = useState<any>(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (formRef.current && !formRef.current.check()) {
      console.log('formError', formError);
      return;
    }

    if (!formValue) return;
    const payload = {
      ProfessionBeginTimeStamp: timeStamp,
      ...formValue
    };
    console.log(payload, editMode);
    setLoading(true);
    if (editMode) {
      const res = await handlePutAdminConsultantRegister({
        ...payload,
        ProfessionBeginTimeStamp: new Date(timeStamp)
      });
      if (res.ok) {
        showToast('اطلاعات با موفقیت به روزرسانی شد!', 'success');
        props.onAcceptConsultant();
        // navigate('/consultant/tnc');
      }
      setLoading(false);
      return;
    }
    const res = await handlePostAdminConsultantRegister({ ...payload, Username: props.username });
    if (res.ok) {
      showToast('فرم با موفقیت ثبت شد!', 'success');
      props.onAcceptConsultant();
      // navigate('/consultant/tnc');
    }
    setLoading(false);
  }, [formValue, formError, formRef, props.username, timeStamp, editMode]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await handleGetAdminConsultantRegister(props.username);

      console.log(res);
      if (res.ok) {
        setFormValue(res.data);
        setTimeStamp(new Date(res.data.ProfessionBeginTimeStamp));
        setEditMode(true);
      }
      setLoading(false);
    })();
  }, [props.username]);

  return (
    <>
      <h4 className="text-h4">اطلاعات مورد نیاز برای نمایش عمومی مشاور را وارد کنید</h4>

      <Form
        ref={formRef}
        onChange={setFormValue}
        onCheck={setFormError}
        formError={formError}
        formValue={formValue}
        model={model}
        onSubmit={handleSubmit}
        checkTrigger="change"
        className="mt-6 text-dark"
        readOnly={loading}>
        <FlexboxGrid>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} lg={8} className="max-w-[100%]">
            <TextField
              name="FullName"
              label="نام و نام خانوادگی"
              type="text"
              accepter={Input}
              dir="rtl"
              full
              req
              placeholder=""
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} lg={8} className="max-w-[100%]">
            <Field
              name="Category"
              label="دسته بندی"
              accepter={InputPicker}
              data={[{ label: 'دسته 1', value: 'دسته 1' }]}
              dir="rtl"
              full
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} lg={8} className="max-w-[100%]">
            <Field
              name="City"
              label="شهر"
              accepter={InputPicker}
              data={[{ label: 'شهر 1', value: 'شهر 1' }]}
              dir="rtl"
              full
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} lg={8} className="max-w-[100%]">
            <Field
              name="Job"
              label="شغل"
              accepter={InputPicker}
              data={[{ label: 'شغل 1', value: 'شغل 1' }]}
              dir="rtl"
              full
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} lg={8} className="max-w-[100%]">
            <Field
              name="Education"
              label="تحصیلات"
              accepter={InputPicker}
              data={[{ label: 'تحصیلات 1', value: 'تحصیلات 1' }]}
              dir="rtl"
              full
              req
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
            <div style={{ position: 'relative' }}>
              <TextField
                className="font-fd cursor-pointer mb-4"
                name="ProfessionBeginTimeStamp"
                type="text"
                dir="rtl"
                full
                accepter={Input}
                readOnly
                value={format(timeStamp, 'dd MMMM yyyy', { locale: faIR })}
                label="زمان شروع فعالیت به عنوان مشاور"
                req
                onClick={() => setCalendarOpen((state) => !state)}
              />
              <div
                style={{
                  position: 'absolute',
                  top: 60,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 1000
                }}>
                <DatePicker
                  onSelectDate={setTimeStamp}
                  open={calendarOpen}
                  setOpen={setCalendarOpen}
                  hideTime
                  hideToday
                  hideConfirm
                />
              </div>
            </div>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} lg={8} className="max-w-[100%]">
            <TextField
              name="PriceFor1H"
              label="قیمت برای یک ساعت (ریال)"
              type="text"
              accepter={Input}
              dir="ltr"
              full
              req
              placeholder=""
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} lg={8} className="max-w-[100%]">
            <TextField
              name="PriceFor30M"
              label="قیمت برای نیم ساعت (ریال)"
              type="text"
              accepter={Input}
              dir="ltr"
              full
              req
              placeholder=""
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%]">
            <TextAreaField
              name="Description"
              label="توضیحات درباره مشاور"
              dir="rtl"
              full
              req
              placeholder=""
            />
          </FlexboxGrid.Item>
        </FlexboxGrid>
        <div className="flex justify-between">
          <Button appearance="primary" className="mr-auto mt-8" type="submit" loading={loading}>
            ثبت نهایی مشاور
          </Button>
        </div>
      </Form>
    </>
  );
};
